// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3JR6f","title":"Images45_title__2iWtU","images":"Images45_images__BlKCO"};